import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 3;
  display: flex;
  justify-content: flex-end;
`

export const Button = styled.button<{ $isCollapsed: boolean }>`
  position: relative;
  outline: none;
  height: 64px;
  gap: 8px;
  padding: 12px 20px;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  pointer-events: none;
  -webkit-tap-highlight-color: transparent;
  color: ${Colors.White};

  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: ${props => (props.$isCollapsed ? '64px' : '100%')};
    height: 100%;
    border-radius: 32px;
    background-color: ${Colors.Blue50};
    transition-property: width;
    transition-duration: 0.3s;
    transition-delay: ${props => (props.$isCollapsed ? '0.2s' : 0)};
    will-change: width;
    pointer-events: auto;
    z-index: -1;
  }

  &:hover:before {
    background-color: ${Colors.Blue60};
  }
`

export const ButtonText = styled.div<{ $isCollapsed: boolean }>`
  ${Typography.sizes.ButtonM};
  font-weight: 600;
  display: block;
  position: relative;
  opacity: ${props => (props.$isCollapsed ? 0 : 1)};
  transition-property: opacity;
  transition-duration: 0.3s;
  transition-delay: ${props => (props.$isCollapsed ? 0 : '0.2s')};
`
